function Marquee(selector, speed) {
  const parentSelector = document.querySelector(selector);
  const clone = parentSelector.innerHTML;
  let i = 0;
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);

  const lastElement = parentSelector.children[parentSelector.children.length - 1];

  setInterval(function () {
    lastElement.style.marginRight = `-${i}px`;
    if (i > lastElement.clientWidth) {
      i = 0;
    }
    i = i + speed;
  }, 0);
}
var speed = 0.3;
if (window.innerWidth < 1200) {
  speed = 0.6;
}
window.addEventListener("load", Marquee(".marquee", speed));
